export const routeNames = {
    SingleCourseFilterWithLesson : 'SingleCourseFilterWithLesson',
    SingleCourseFilter: 'SingleCourseFilter',
    ProfilePage:'Profile',
    FavouritesPage: 'Favourites',
}
